import { OrganizationMarketplace } from '@spike/marketplace-model';
import clsx from 'clsx';
import DefaultTableEmptyState from 'components/UI/V3/Table/EmptyState/DefaultTableEmptyState';
import { TableBody } from 'components/UI/V3/Table/Body/TableBody';
import { TableHeader } from 'components/UI/V3/Table/Header/TableHeader';
import { TableHeaderCell } from 'components/UI/V3/Table/HeaderCell/TableHeaderCell';
import { Table } from 'components/UI/V3/Table/Table';
import { PaginationProps } from 'components/UI/V3/Pagination/Pagination';
import { FunctionComponent } from 'react';
import LocationsTableRow from './LocationsTableRow';
import styles from './LocationsTable.module.scss';

interface LocationsTableProps {
    locations: Array<OrganizationMarketplace>;
    page: number;
    pageSize: number;
    totalCount: number;
    fallbackCountryId?: string;
    className?: string;
    onPageChange?: PaginationProps['onPageChange'];
    onPageSizeChange?: PaginationProps['onSizeChange'];
}

export const LocationsTable: FunctionComponent<LocationsTableProps> = props => {
    const totalPages = props.pageSize > 0 ? Math.max(1, Math.ceil(props.totalCount / props.pageSize)) : 1;

    if (props.totalCount === 0) {
        return (
            <Table
                className={clsx(styles.table, props.className)}
                fullHeight={true}
            >
                <TableBody className={styles.tableBody}>
                    <DefaultTableEmptyState />
                </TableBody>
            </Table>
        );
    }

    return (
        <Table
            pagination={{
                page: props.page,
                totalPages,
                size: props.pageSize
            }}
            onPageChange={props.onPageChange}
            onSizeChange={props.onPageSizeChange}
            className={props.className}
            fullHeight={true}
        >
            <TableHeader>
                <TableHeaderCell>Name</TableHeaderCell>
                <TableHeaderCell>Address</TableHeaderCell>
                <TableHeaderCell>City, State</TableHeaderCell>
                <TableHeaderCell>Phone</TableHeaderCell>
                <TableHeaderCell>Email</TableHeaderCell>
            </TableHeader>
            <TableBody>
                {props.locations.map(location => (
                    <LocationsTableRow
                        key={location.id}
                        location={location}
                        fallbackCountryId={props.fallbackCountryId}
                    />
                ))}
            </TableBody>
        </Table>
    );
};

export default LocationsTable;
